




























import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import { loadFromLocal } from '@/utils/local'
import { downloadPaper } from './model/api'

const TIMEOUT_SECONDS = 5
let timeback = 0

@Component({
  components: { MainTemplate }
})
export default class DownloadFinsh extends Vue {
  public imgs = ['.jpg', '.jpeg', '.bmp', 'gif', 'png', 'pdf']
  public wait = TIMEOUT_SECONDS
  public get url() {
    let str = this.$route.query.url
    return str
  }
  public get subjectId() {
    return this.$route.query.subject_id
  }
  public get site() {
    return this.$route.query.site
  }
  public get paperId() {
    return this.$route.query.paper_id
  }
  public get userName() {
    return this.$store.state.user_info.nickname
  }
  public get home() {
    let home = this.$route.query.home
    return home && home !== 'undefined' ? '/' + home : '/question'
  }
  public mounted() {
    if (!this.userName) {
      location.href = this.home
      return
    }
    if (this.url) {
      this.downloadFile(decodeURIComponent(this.url + ''))
    }
    this.time()
  }
  public reDownload() {
    if (this.url) {
      this.downloadFile(this.url + '')
    }
  }
  public async getPaperDoc() {
    let req = {
      subject_id: this.subjectId,
      paper_id: this.paperId
    }
    let data = await downloadPaper(req)
    location.href = data.data.doc_src
  }
  public downloadFile(url) {
    if (
      this.imgs.some((itm) => {
        return url.toLowerCase().indexOf(itm)
      })
    ) {
      let alink = document.createElement('a')
      alink.href = url
      alink.download = 'url' //图片名
      alink.click()
    } else {
      try {
        let elemIF = document.createElement('iframe')
        elemIF.src = url
        elemIF.style.display = 'none'
        document.body.appendChild(elemIF)
      } catch (e) {
        console.log(e)
      }
    }
  }
  public time() {
    if (this.wait === 0) {
      location.href = this.home
      // this.wait = TIMEOUT_SECONDS
    } else {
      this.wait--
      timeback = setTimeout(() => {
        this.time()
      }, 1000)
    }
  }
}
